import { useTrans } from '@/shared/hooks/useTranslation';
import { ActivityTimelinePanel } from '@/view/features/observability/ActivityTimelinePanel';
import { Drawer } from '@/view/shared/Drawer';
import { useActivityDrawerViewModel } from '@/viewmodel/features/observability';
import type { JSX } from 'react';

export function ActivityDrawer(): JSX.Element | null {
  const { t } = useTrans();
  const { isOpen, correlationId, workspaceId, close } = useActivityDrawerViewModel();

  if (!isOpen) return null;

  return (
    <Drawer
      isOpen={isOpen}
      setIsOpen={(open) => {
        if (!open) close();
      }}
      title={t('observability.activity.title')}
    >
      <div className="w-full max-w-md">
        <ActivityTimelinePanel
          correlationId={correlationId}
          workspaceId={workspaceId}
          defaultOpen
        />
      </div>
    </Drawer>
  );
}
